import List from 'semantic-ui-react/dist/es/elements/List';
import './List.css';

export default List;
